export default __webpack_public_path__ + "static/grafik-85d1418b60a313f8a738e096fbca4ea3.svg";